/**
 * 수령한 곳에서 반납 — 파트너 정책 opt-in (10-01, hinata 캠핑 장비).
 *
 * `products.specifications.returnAtPickup === true` 인 상품만 켜진다(편도 반납
 * `oneWayReturnOptionOrder`·하루당 옵션 `perDayOptionOrders` 와 같은 플래그 방식,
 * DB 구조 변경 없음). 켜진 상품에서는:
 *  - 예약 카드가 반납 지점 선택칸을 숨기고 반납 = 수령 지점으로 고정한다
 *  - 서버(장바구니 담기·getCart·직접 결제 검증 → PortOne/Stripe 저장)가 클라이언트
 *    값을 믿지 않고 반납 지점/방법을 수령 쪽 값으로 덮어쓴다
 *
 * 반납이 있는 건 daily 예약뿐이라 다른 rental_type 은 건드리지 않는다.
 * 플래그가 없는 상품(다른 파트너 전부)은 아무 변화가 없다.
 */

export const RETURN_AT_PICKUP_SPEC_KEY = "returnAtPickup";

/** `specifications.returnAtPickup` 이 정확히 `true` 일 때만 켜짐(문자열·숫자 불인정). */
export function readReturnAtPickup(
  specifications: unknown,
): boolean {
  if (!specifications || typeof specifications !== "object") return false;
  return (
    (specifications as Record<string, unknown>)[RETURN_AT_PICKUP_SPEC_KEY] === true
  );
}

/** 클라이언트용 — 켜진 상품이면 반납 지점 = 수령 지점, 아니면 고객 선택 그대로. */
export function resolveReturnBranch<T extends string | null | undefined>(
  specifications: unknown,
  pickupBranchId: T,
  returnBranchId: T,
): T {
  return readReturnAtPickup(specifications) ? pickupBranchId : returnBranchId;
}

/**
 * 서버용 — 반납 구간(지점 + 방법)을 확정한다. 켜진 상품의 daily 예약이면 수령 구간을
 * 그대로 복사하고(택배·숙소 수령이면 방법도 같이), 그 밖에는 입력 그대로 돌려준다.
 */
export function resolveReturnLeg<
  B extends string | null | undefined,
  M extends string | null | undefined,
>(args: {
  specifications: unknown;
  rentalType: string | null | undefined;
  pickupBranchId: B;
  pickupMethodType: M;
  returnBranchId: B;
  returnMethodType: M;
}): { returnBranchId: B; returnMethodType: M; forced: boolean } {
  if (args.rentalType === "daily" && readReturnAtPickup(args.specifications)) {
    return {
      returnBranchId: args.pickupBranchId,
      returnMethodType: args.pickupMethodType,
      forced: true,
    };
  }
  return {
    returnBranchId: args.returnBranchId,
    returnMethodType: args.returnMethodType,
    forced: false,
  };
}
